"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOrderStatus = void 0;
const cloneObject_1 = require("../cloneObject");
const addOrderLog_1 = require("./addOrderLog");
const updateOrder_1 = require("./updateOrder");
const updateOrderStatus = async (supabase, order, status) => {
    const updated_order = (0, cloneObject_1.cloneObject)(order);
    updated_order.status = status;
    try {
        console.log("TRY TO ADD ORDER LOG", {
            created_by: order.client?.id,
            type: "Update",
            order_id: order?.id,
            detail: {
                message: "Order Status Changed - " + status,
            },
        });
        await (0, addOrderLog_1.addOrderLog)(supabase, {
            created_by: order.client?.id,
            type: "Update",
            order_id: order?.id,
            detail: {
                message: "Order Status Changed - " + status,
            },
        });
    }
    catch (e) {
        console.log("Error adding order log", e);
    }
    // set the order status to CONFIRMING_GOLF
    await (0, updateOrder_1.updateOrder)(supabase, updated_order);
};
exports.updateOrderStatus = updateOrderStatus;
